export default {
    error: 'Error',
    wrongPassword: 'Contraseña incorrecta',
}